const countryOptions = [
  { id: "HK", name: "Hongkong (HK)" },
  { id: "ID", name: "Indonesia (ID)" },
  { id: "TW", name: "Taiwan (TW)" },
];
const statusOptions = [
  { id: "FREE", name: "FREE" },
  { id: "ACTIVE", name: "ACTIVE" },
  { id: "EXPIRE", name: "EXPIRE" },
];

const mapToOptions = [
  { id: "M21", name: "M21" },
  { id: "SIM", name: "SIM" },
  { id: "NULL", name: "NULL" },
];

const poolOptions = [
  { id: 1, name: "YES" },
  { id: 0, name: "NO" },
];

const autoRenewalOptions = [
  { id: 1, name: "YES" },
  { id: 0, name: "NO" },
];

export {
  countryOptions,
  statusOptions,
  mapToOptions,
  poolOptions,
  autoRenewalOptions,
};
